import { render, staticRenderFns } from "./SiAccount.vue?vue&type=template&id=2f4135f4&"
import script from "./SiAccount.vue?vue&type=script&lang=js&"
export * from "./SiAccount.vue?vue&type=script&lang=js&"
import style0 from "./SiAccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports